import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import { HomePage } from '../home/home';


@IonicPage()
@Component({
  selector: 'page-registrar',
  templateUrl: 'registrar.html',
})
export class RegistrarPage {
 nombre;
 apellidos;
 celular;
 telefono;
 nif;
 referencia;
 dirrecion;
 ciudad;
 email;
 password;
 cPassword;
 language = {};
  constructor(public navCtrl: NavController, public navParams: NavParams,public http: Http,public alertCtrl: AlertController) {
    this.http.get('https://ebenlovequickpc.com/i18n/languaje.php?lang='+localStorage.getItem('language')).subscribe((data)=>{
      this.language = data.json();
    })
  }

  ionViewDidLoad() {
  }
  registrar(){

    let params = "nombre="+this.nombre+"&apellidos="+this.apellidos+"&celular="+this.celular+"&telefono="+this.telefono+"&nif="+this.nif+"&referencia="+this.referencia+"&dirrecion="+this.dirrecion+"&ciudad="+this.ciudad+"&email="+this.email+"&pw="+this.password;
      this.http.get('https://ebenlovequickpc.com/API/perfil.php?cl=insert&'+params).subscribe((data)=>{
          if(data.status==200){
            this.navCtrl.setRoot(HomePage);
          }

      });
  }
  validar(){
    if(this.nombre && this.apellidos && this.celular && this.nif && this.email && this.password && this.cPassword && this.password==this.cPassword){
      return false;
    }else{
      return true;
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/registrar/registrar.ts